import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../ProductsConfig';
import { termDepositOverviewConfig } from './term-deposit-overview-config/CZ';
import { settingsDetails } from './settings-details-config/CZ';
import { savingEnvelopes } from './saving-envelopes-config/CZ';

export const savings: DeepPartial<SavingsConfig> = {
    overview: {
        termDeposit: termDepositOverviewConfig,
    },
    showDisposableTogetherWithBalanceAndTargetAmountInOverviewCard: true,
    statements: {
        createStatement: false,
        deliveryDefinitions: {
            periodicity: [
                'DAILY',
                'WEEKLY',
                'MONTHLY',
                'QUARTERLY',
                'HALFYEARLY',
                'YEARLY',
                '10_YEARLY',
            ],
            canCreateDefinition: false,
            channelEditable: true,
        },
    },
    allowedPurposeSavingsFlags: ['domesticTransferAllowed'],
    associatedCards: {
        enabled: false,
    },
    settingsDetails,
    savingEnvelopes,
    newTransfer: {
        sideMenuLabel: 'savings.main.newWithdrawal',
    },
    layout: {
        productInfo: {
            showBalanceAndDisposableAmounts: true,
        },
    },
};
